import { z } from 'zod';
export const PortalUserStatusSchema = z.enum(['ACTIVE', 'ACTIVATING', 'INACTIVE', 'DEACTIVATING']);
export const PortalUserStatus = PortalUserStatusSchema.enum;
export const PortalUserSchema = z.object({
    auth0Id: z.string(),
    createdBy: z.string(),
    dateCreated: z.string().datetime(),
    dateModified: z.string().datetime(),
    email: z.string(),
    entityPermissions: z.string().array(),
    externalUserId: z.string(),
    modifiedBy: z.string(),
    name: z.string(),
    phoneNumber: z.string().optional(),
    portalUserId: z.string(),
    status: PortalUserStatusSchema,
});
export const isPortalUserActive = (portalUser) => portalUser.status === PortalUserStatus.ACTIVATING || portalUser.status === PortalUserStatus.ACTIVE;
